import BankLinkingModal from './BankLinkingModal'

export default BankLinkingModal
